import { render, staticRenderFns } from "./component-modal.vue?vue&type=template&id=49c06af4"
import script from "./component-modal.vue?vue&type=script&lang=js"
export * from "./component-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports